import type { PainelNotification } from '@/lib/painel-notifications';
import { apiGet } from './api-client';

export async function getNotifications(): Promise<PainelNotification[]> {
  try {
    const res = await apiGet<{ data: PainelNotification[] }>('/admin/notifications', true);
    return res.data ?? [];
  } catch {
    return [];
  }
}
